import React from 'react'
import classNames from 'classnames'
import { compose } from 'recompose'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.min.css'

const DateInput = (props) => {
  const { label, placeHolder, require, editable, dateFormat='dd MMMM yyyy HH:mm', input, specialOnChange, meta: { touched, error } } = props
  return (
    <div className='fieldRow'>
      <span className='fieldLabel'>
        {label}
        {require ? <span className='require'>*</span> : null}
        {touched && error ? <span className='error'>{error}</span> : null}
      </span>
      <div className={`${classNames('fieldInput', { error: touched && error })} ${editable!==false?'editableDateInput':''}`}>
        <DatePicker 
          className='dateInput'
          selected={input.value}
          showTimeSelect
          onChange={date => {
            input.onChange(date)
            if (specialOnChange) {
              specialOnChange(date, input.value)
            }
          }}
          dateFormat={dateFormat}
          minDate={props.minDate||null}
          disabled={editable === false}
          placeholder={placeHolder}
        />
      </div>
    </div>
  )
}

export default compose()(DateInput)